// removed by extract-text-webpack-plugin
module.exports = {"section":"section__1_Dxv","card-title":"card-title__3mBvQ","table-row":"table-row__36NCZ","reduction-notification":"reduction-notification__2SNYp","heading":"heading__2Qxeq","body":"body__kIaJP","error":"error__38MPc"};


//////////////////
// WEBPACK FOOTER
// ./styles/dashboard/redeemSummary.scss
// module id = 1249
// module chunks = 68